import React from 'react';

import AddIcon from 'icons/add.svg';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import Tooltip from 'components/application/Tooltip';

export default function AddButton(props) {
  const btnContents = (
    <>
      <AddIcon className='m-l--8' height={24} width={24} />
      <span>{props.text}</span>
    </>
  );

  return (
    <div className='tooltip-parent'>
      <OutlinedButton
        color='grey'
        disabled={props.disabled}
        onClick={props.onClick ? props.onClick : () => undefined}
        size='sm'
      >
        {btnContents}
      </OutlinedButton>
      {props.tooltipText && (
        <Tooltip placement='top' tooltip={props.tooltipText} trigger='hover' />
      )}
    </div>
  );
}

AddButton.defaultProps = {
  customStyleClasses: '',
};
